import { useState, useEffect } from "react";

export function useBreakpoint() {
    const [width, setWidth] = useState(globalThis.innerWidth);

    useEffect(() => {
        const handler = () => setWidth(globalThis.innerWidth);
        globalThis.addEventListener("resize", handler);
        return () => globalThis.removeEventListener("resize", handler);
    }, []);

    return {
        isMobile:  width < 768,
        isTablet:  width >= 768 && width < 1024,
        isDesktop: width >= 1024,
        isLarge:   width >= 1440,
        width,
    };
}
